import React from 'react';
import './categorywrap.scss';
import Parser from 'html-react-parser';

import CLeftMenu from './leftmenu/cleftmenu.js';
import { renderRoutes } from 'react-router-config';

export const CategoryWrap = ({ route }) => {
  return (
    <section className='category-wrap f-center'>
      <div className='f-container del-margin'>
        <div className='f-row'>
          <div className='f-item f-item-3'>
            <CLeftMenu />
          </div>
          <div className='f-item f-item-9'>
            {renderRoutes(route.routes, { child:route.routes })}
          </div>
        </div>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/client/components/categorywrap/categorywrap.jsx